module.exports = {
	"contractName": "Citizens",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "targetMember",
					"type": "address"
				}
			],
			"name": "removeMember",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesOwnedAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "memberId",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "members",
			"outputs": [
				{
					"name": "member",
					"type": "address"
				},
				{
					"name": "name",
					"type": "string"
				},
				{
					"name": "memberSince",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "targetMember",
					"type": "address"
				},
				{
					"name": "newName",
					"type": "string"
				}
			],
			"name": "editMember",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "targetMember",
					"type": "address"
				},
				{
					"name": "memberName",
					"type": "string"
				}
			],
			"name": "addMember",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "numCitizens",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_citizen",
					"type": "address"
				}
			],
			"name": "getCitizen",
			"outputs": [
				{
					"name": "citizenId",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "ownedAddress",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "member",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "isMember",
					"type": "bool"
				}
			],
			"name": "MembershipChanged",
			"type": "event"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "128:2479:0:-;;;718:339;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;803:12;776:18;;:40;;;;;;;;;;;;;;;;;;885:16;895:1;885:16;;;;;;;;;;;;;:9;;;;;:16;;;:::i;:::-;926:1;912:11;:15;;;;998:51;1008:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;998:51;;;;;;;;;;;;;;;;;;:9;;;;;:51;;;:::i;:::-;718:339;128:2479;;1285:551;1504:7;1629:16;1397:1;1371:8;:22;1380:12;1371:22;;;;;;;;;;;;;;;;:27;1363:36;;;;;;;;1430:1;1414:12;:17;;;;1410:84;;;1469:12;1455:26;;:10;:26;;;1447:35;;;;;;;;1410:84;1514:8;:22;1523:12;1514:22;;;;;;;;;;;;;;;;1504:32;;1572:7;:14;;;;1547:8;:22;1556:12;1547:22;;;;;;;;;;;;;;;:39;;;;1602:7;:16;;;;;;;;;;;:::i;:::-;1597:21;;1648:7;1656:2;1648:11;;;;;;;;;;;;;;;;;;;;1629:30;;1681:12;1670:1;:8;;;:23;;;;;;;;;;;;;;;;;;1720:3;1704:1;:13;;:19;;;;1743:10;1734:1;:6;;:19;;;;;;;;;;;;:::i;:::-;;1764:37;1782:12;1796:4;1764:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1827:1;1812:11;;:16;;;;;;;;;;;1285:551;;;;:::o;128:2479::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "128:2479:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2341:261;;;;;;;;;;;;;;;;;;;;;;;;;;;;305:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;197:41;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;275:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1844:322;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1285:551;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;245:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;519:144;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2341:261;2493:7;2437:1;2411:8;:22;2420:12;2411:22;;;;;;;;;;;;;;;;:27;;:70;;;;;2469:12;2455:26;;:10;:26;;;2411:70;2403:79;;;;;;;;2503:8;:22;2512:12;2503:22;;;;;;;;;;;;;;;;2493:32;;2543:7;2551:2;2543:11;;;;;;;;;;;;;;;;;;;;;2536:18;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;2572:8;:22;2581:12;2572:22;;;;;;;;;;;;;;;2565:29;;;2341:261;;:::o;305:31::-;;;;;;;;;;;;;:::o;197:41::-;;;;;;;;;;;;;;;;;:::o;275:23::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1844:322::-;2010:7;2053:16;1954:1;1928:8;:22;1937:12;1928:22;;;;;;;;;;;;;;;;:27;;:70;;;;;1986:12;1972:26;;:10;:26;;;1928:70;1920:79;;;;;;;;2020:8;:22;2029:12;2020:22;;;;;;;;;;;;;;;;2010:32;;2072:7;2080:2;2072:11;;;;;;;;;;;;;;;;;;;;2053:30;;2103:7;2094:1;:6;;:16;;;;;;;;;;;;:::i;:::-;;2121:37;2139:12;2153:4;2121:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1844:322;;;;:::o;1285:551::-;1504:7;1629:16;1397:1;1371:8;:22;1380:12;1371:22;;;;;;;;;;;;;;;;:27;1363:36;;;;;;;;1430:1;1414:12;:17;;;;1410:84;;;1469:12;1455:26;;:10;:26;;;1447:35;;;;;;;;1410:84;1514:8;:22;1523:12;1514:22;;;;;;;;;;;;;;;;1504:32;;1572:7;:14;;;;1547:8;:22;1556:12;1547:22;;;;;;;;;;;;;;;:39;;;;1602:7;:16;;;;;;;;;;;:::i;:::-;1597:21;;1648:7;1656:2;1648:11;;;;;;;;;;;;;;;;;;;;1629:30;;1681:12;1670:1;:8;;;:23;;;;;;;;;;;;;;;;;;1720:3;1704:1;:13;;:19;;;;1743:10;1734:1;:6;;:19;;;;;;;;;;;;:::i;:::-;;1764:37;1782:12;1796:4;1764:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1827:1;1812:11;;:16;;;;;;;;;;;1285:551;;;;:::o;245:23::-;;;;:::o;519:144::-;581:14;607:7;617:8;:18;626:8;617:18;;;;;;;;;;;;;;;;607:28;;653:2;646:9;;519:144;;;;:::o;128:2479::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.16;\r\n\r\ninterface Owned {\r\n    function getOwner() constant external returns (address contractOwner);\r\n}\r\n\r\ncontract Citizens {\r\n    \r\n    // Contract Variables and events\r\n    mapping (address => uint) public memberId;\r\n    uint public numCitizens;\r\n    Member[] public members;\r\n    Owned public sharesOwnedAddress;\r\n\r\n    event MembershipChanged(address member, bool isMember);\r\n   \r\n    struct Member {\r\n        address member;\r\n        string name;\r\n        uint memberSince;\r\n    }\r\n    \r\n    function getCitizen(address _citizen) constant public returns(uint citizenId){\r\n        uint id = memberId[_citizen];\r\n        return id;\r\n    }\r\n\r\n    /**\r\n     * Constructor function\r\n     */\r\n    function Citizens (Owned ownedAddress)  public {\r\n        sharesOwnedAddress = Owned(ownedAddress);\r\n        // It’s necessary to add an empty first member\r\n        addMember(0, \"\");\r\n        numCitizens = 0;\r\n        // and let's add the founder, to save a step later\r\n        addMember(sharesOwnedAddress.getOwner(), 'Founder');\r\n    }\r\n\r\n    /**\r\n     * Add member\r\n     *\r\n     * Make `targetMember` a member named `memberName`\r\n     *\r\n     * @param targetMember ethereum address to be added\r\n     * @param memberName public name for that member\r\n     */\r\n    function addMember(address targetMember, string memberName) public {\r\n        require(memberId[targetMember] == 0);\r\n        if (targetMember != 0){\r\n            require(msg.sender == targetMember);\r\n        }\r\n        uint id = memberId[targetMember];\r\n        memberId[targetMember] = members.length;\r\n        id = members.length++;\r\n        Member storage m = members[id];\r\n        m.member = targetMember;\r\n        m.memberSince = now;\r\n        m.name = memberName;\r\n        MembershipChanged(targetMember, true);\r\n        numCitizens += 1;\r\n    }\r\n\r\n    function editMember(address targetMember, string newName) public {\r\n        require(memberId[targetMember] != 0\r\n            && msg.sender == targetMember);\r\n        uint id = memberId[targetMember];\r\n        Member storage m = members[id];\r\n        m.name = newName;\r\n        MembershipChanged(targetMember, true);\r\n    }\r\n    /**\r\n     * Remove member\r\n     *\r\n     * @notice Remove membership from `targetMember`\r\n     *\r\n     * @param targetMember ethereum address to be removed\r\n     */\r\n    function removeMember(address targetMember) public {\r\n        require(memberId[targetMember] != 0\r\n            && msg.sender == targetMember);\r\n        uint id = memberId[targetMember];\r\n        delete members[id];\r\n        delete memberId[targetMember];\r\n    }\r\n\r\n}",
	"sourcePath": "C:\\Users\\nktpa\\Desktop\\truffle-react-auth\\contracts\\Citizens.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/C/Users/nktpa/Desktop/truffle-react-auth/contracts/Citizens.sol",
			"exportedSymbols": {
				"Citizens": [
					235
				],
				"Owned": [
					7
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 1,
				"name": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						7
					],
					"name": "Owned",
					"scope": 236
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getOwner",
							"payable": false,
							"scope": 7,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 2,
								"name": "ParameterList",
								"src": "68:2:0"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "contractOwner",
											"scope": 6,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 3,
												"name": "ElementaryTypeName",
												"src": "98:7:0"
											}
										],
										"id": 4,
										"name": "VariableDeclaration",
										"src": "98:21:0"
									}
								],
								"id": 5,
								"name": "ParameterList",
								"src": "97:23:0"
							}
						],
						"id": 6,
						"name": "FunctionDefinition",
						"src": "51:70:0"
					}
				],
				"id": 7,
				"name": "ContractDefinition",
				"src": "28:96:0"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						235
					],
					"name": "Citizens",
					"scope": 236
				},
				"children": [
					{
						"attributes": {
							"constant": false,
							"name": "memberId",
							"scope": 235,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => uint256)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => uint256)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 8,
										"name": "ElementaryTypeName",
										"src": "206:7:0"
									},
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 9,
										"name": "ElementaryTypeName",
										"src": "217:4:0"
									}
								],
								"id": 10,
								"name": "Mapping",
								"src": "197:25:0"
							}
						],
						"id": 11,
						"name": "VariableDeclaration",
						"src": "197:41:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "numCitizens",
							"scope": 235,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint",
									"type": "uint256"
								},
								"id": 12,
								"name": "ElementaryTypeName",
								"src": "245:4:0"
							}
						],
						"id": 13,
						"name": "VariableDeclaration",
						"src": "245:23:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "members",
							"scope": 235,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "struct Citizens.Member storage ref[] storage ref",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"length": null,
									"type": "struct Citizens.Member storage ref[] storage pointer"
								},
								"children": [
									{
										"attributes": {
											"contractScope": null,
											"name": "Member",
											"referencedDeclaration": 31,
											"type": "struct Citizens.Member storage pointer"
										},
										"id": 14,
										"name": "UserDefinedTypeName",
										"src": "275:6:0"
									}
								],
								"id": 15,
								"name": "ArrayTypeName",
								"src": "275:8:0"
							}
						],
						"id": 16,
						"name": "VariableDeclaration",
						"src": "275:23:0"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesOwnedAddress",
							"scope": 235,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Owned",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Owned",
									"referencedDeclaration": 7,
									"type": "contract Owned"
								},
								"id": 17,
								"name": "UserDefinedTypeName",
								"src": "305:5:0"
							}
						],
						"id": 18,
						"name": "VariableDeclaration",
						"src": "305:31:0"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "MembershipChanged"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "member",
											"scope": 24,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 19,
												"name": "ElementaryTypeName",
												"src": "369:7:0"
											}
										],
										"id": 20,
										"name": "VariableDeclaration",
										"src": "369:14:0"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "isMember",
											"scope": 24,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 21,
												"name": "ElementaryTypeName",
												"src": "385:4:0"
											}
										],
										"id": 22,
										"name": "VariableDeclaration",
										"src": "385:13:0"
									}
								],
								"id": 23,
								"name": "ParameterList",
								"src": "368:31:0"
							}
						],
						"id": 24,
						"name": "EventDefinition",
						"src": "345:55:0"
					},
					{
						"attributes": {
							"canonicalName": "Citizens.Member",
							"name": "Member",
							"scope": 235,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"constant": false,
									"name": "member",
									"scope": 31,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 25,
										"name": "ElementaryTypeName",
										"src": "436:7:0"
									}
								],
								"id": 26,
								"name": "VariableDeclaration",
								"src": "436:14:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "name",
									"scope": 31,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "string storage pointer",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "string",
											"type": "string storage pointer"
										},
										"id": 27,
										"name": "ElementaryTypeName",
										"src": "461:6:0"
									}
								],
								"id": 28,
								"name": "VariableDeclaration",
								"src": "461:11:0"
							},
							{
								"attributes": {
									"constant": false,
									"name": "memberSince",
									"scope": 31,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint",
											"type": "uint256"
										},
										"id": 29,
										"name": "ElementaryTypeName",
										"src": "483:4:0"
									}
								],
								"id": 30,
								"name": "VariableDeclaration",
								"src": "483:16:0"
							}
						],
						"id": 31,
						"name": "StructDefinition",
						"src": "411:96:0"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getCitizen",
							"payable": false,
							"scope": 235,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_citizen",
											"scope": 47,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 32,
												"name": "ElementaryTypeName",
												"src": "539:7:0"
											}
										],
										"id": 33,
										"name": "VariableDeclaration",
										"src": "539:16:0"
									}
								],
								"id": 34,
								"name": "ParameterList",
								"src": "538:18:0"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "citizenId",
											"scope": 47,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 35,
												"name": "ElementaryTypeName",
												"src": "581:4:0"
											}
										],
										"id": 36,
										"name": "VariableDeclaration",
										"src": "581:14:0"
									}
								],
								"id": 37,
								"name": "ParameterList",
								"src": "580:16:0"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												39
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "id",
													"scope": 47,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 38,
														"name": "ElementaryTypeName",
														"src": "607:4:0"
													}
												],
												"id": 39,
												"name": "VariableDeclaration",
												"src": "607:7:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 11,
															"type": "mapping(address => uint256)",
															"value": "memberId"
														},
														"id": 40,
														"name": "Identifier",
														"src": "617:8:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 33,
															"type": "address",
															"value": "_citizen"
														},
														"id": 41,
														"name": "Identifier",
														"src": "626:8:0"
													}
												],
												"id": 42,
												"name": "IndexAccess",
												"src": "617:18:0"
											}
										],
										"id": 43,
										"name": "VariableDeclarationStatement",
										"src": "607:28:0"
									},
									{
										"attributes": {
											"functionReturnParameters": 37
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 39,
													"type": "uint256",
													"value": "id"
												},
												"id": 44,
												"name": "Identifier",
												"src": "653:2:0"
											}
										],
										"id": 45,
										"name": "Return",
										"src": "646:9:0"
									}
								],
								"id": 46,
								"name": "Block",
								"src": "596:67:0"
							}
						],
						"id": 47,
						"name": "FunctionDefinition",
						"src": "519:144:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "Citizens",
							"payable": false,
							"scope": 235,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "ownedAddress",
											"scope": 75,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Owned",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Owned",
													"referencedDeclaration": 7,
													"type": "contract Owned"
												},
												"id": 48,
												"name": "UserDefinedTypeName",
												"src": "737:5:0"
											}
										],
										"id": 49,
										"name": "VariableDeclaration",
										"src": "737:18:0"
									}
								],
								"id": 50,
								"name": "ParameterList",
								"src": "736:20:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 51,
								"name": "ParameterList",
								"src": "765:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Owned"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 18,
															"type": "contract Owned",
															"value": "sharesOwnedAddress"
														},
														"id": 52,
														"name": "Identifier",
														"src": "776:18:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Owned",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Owned_$7",
																			"typeString": "contract Owned"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 7,
																	"type": "type(contract Owned)",
																	"value": "Owned"
																},
																"id": 53,
																"name": "Identifier",
																"src": "797:5:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 49,
																	"type": "contract Owned",
																	"value": "ownedAddress"
																},
																"id": 54,
																"name": "Identifier",
																"src": "803:12:0"
															}
														],
														"id": 55,
														"name": "FunctionCall",
														"src": "797:19:0"
													}
												],
												"id": 56,
												"name": "Assignment",
												"src": "776:40:0"
											}
										],
										"id": 57,
										"name": "ExpressionStatement",
										"src": "776:40:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
																	"typeString": "literal_string \"\""
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 155,
															"type": "function (address,string memory)",
															"value": "addMember"
														},
														"id": 58,
														"name": "Identifier",
														"src": "885:9:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 59,
														"name": "Literal",
														"src": "895:1:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "string",
															"type": "literal_string \"\"",
															"value": ""
														},
														"id": 60,
														"name": "Literal",
														"src": "898:2:0"
													}
												],
												"id": 61,
												"name": "FunctionCall",
												"src": "885:16:0"
											}
										],
										"id": 62,
										"name": "ExpressionStatement",
										"src": "885:16:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 13,
															"type": "uint256",
															"value": "numCitizens"
														},
														"id": 63,
														"name": "Identifier",
														"src": "912:11:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 64,
														"name": "Literal",
														"src": "926:1:0"
													}
												],
												"id": 65,
												"name": "Assignment",
												"src": "912:15:0"
											}
										],
										"id": 66,
										"name": "ExpressionStatement",
										"src": "912:15:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_stringliteral_6f106442475fbbbcd1baf05afd49b3723c64a1d7e7517647d44b5a06e44d1746",
																	"typeString": "literal_string \"Founder\""
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 155,
															"type": "function (address,string memory)",
															"value": "addMember"
														},
														"id": 67,
														"name": "Identifier",
														"src": "998:9:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"arguments": [
																null
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "address",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "getOwner",
																	"referencedDeclaration": 6,
																	"type": "function () view external returns (address)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 18,
																			"type": "contract Owned",
																			"value": "sharesOwnedAddress"
																		},
																		"id": 68,
																		"name": "Identifier",
																		"src": "1008:18:0"
																	}
																],
																"id": 69,
																"name": "MemberAccess",
																"src": "1008:27:0"
															}
														],
														"id": 70,
														"name": "FunctionCall",
														"src": "1008:29:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "466f756e646572",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "string",
															"type": "literal_string \"Founder\"",
															"value": "Founder"
														},
														"id": 71,
														"name": "Literal",
														"src": "1039:9:0"
													}
												],
												"id": 72,
												"name": "FunctionCall",
												"src": "998:51:0"
											}
										],
										"id": 73,
										"name": "ExpressionStatement",
										"src": "998:51:0"
									}
								],
								"id": 74,
								"name": "Block",
								"src": "765:292:0"
							}
						],
						"id": 75,
						"name": "FunctionDefinition",
						"src": "718:339:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "addMember",
							"payable": false,
							"scope": 235,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "targetMember",
											"scope": 155,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 76,
												"name": "ElementaryTypeName",
												"src": "1304:7:0"
											}
										],
										"id": 77,
										"name": "VariableDeclaration",
										"src": "1304:20:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "memberName",
											"scope": 155,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 78,
												"name": "ElementaryTypeName",
												"src": "1326:6:0"
											}
										],
										"id": 79,
										"name": "VariableDeclaration",
										"src": "1326:17:0"
									}
								],
								"id": 80,
								"name": "ParameterList",
								"src": "1303:41:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 81,
								"name": "ParameterList",
								"src": "1352:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 295,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 82,
														"name": "Identifier",
														"src": "1363:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "==",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 11,
																			"type": "mapping(address => uint256)",
																			"value": "memberId"
																		},
																		"id": 83,
																		"name": "Identifier",
																		"src": "1371:8:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 77,
																			"type": "address",
																			"value": "targetMember"
																		},
																		"id": 84,
																		"name": "Identifier",
																		"src": "1380:12:0"
																	}
																],
																"id": 85,
																"name": "IndexAccess",
																"src": "1371:22:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 86,
																"name": "Literal",
																"src": "1397:1:0"
															}
														],
														"id": 87,
														"name": "BinaryOperation",
														"src": "1371:27:0"
													}
												],
												"id": 88,
												"name": "FunctionCall",
												"src": "1363:36:0"
											}
										],
										"id": 89,
										"name": "ExpressionStatement",
										"src": "1363:36:0"
									},
									{
										"attributes": {
											"falseBody": null
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "!=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 77,
															"type": "address",
															"value": "targetMember"
														},
														"id": 90,
														"name": "Identifier",
														"src": "1414:12:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 91,
														"name": "Literal",
														"src": "1430:1:0"
													}
												],
												"id": 92,
												"name": "BinaryOperation",
												"src": "1414:17:0"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "tuple()",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			],
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 295,
																			"type": "function (bool) pure",
																			"value": "require"
																		},
																		"id": 93,
																		"name": "Identifier",
																		"src": "1447:7:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "==",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 292,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 94,
																						"name": "Identifier",
																						"src": "1455:3:0"
																					}
																				],
																				"id": 95,
																				"name": "MemberAccess",
																				"src": "1455:10:0"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 77,
																					"type": "address",
																					"value": "targetMember"
																				},
																				"id": 96,
																				"name": "Identifier",
																				"src": "1469:12:0"
																			}
																		],
																		"id": 97,
																		"name": "BinaryOperation",
																		"src": "1455:26:0"
																	}
																],
																"id": 98,
																"name": "FunctionCall",
																"src": "1447:35:0"
															}
														],
														"id": 99,
														"name": "ExpressionStatement",
														"src": "1447:35:0"
													}
												],
												"id": 100,
												"name": "Block",
												"src": "1432:62:0"
											}
										],
										"id": 101,
										"name": "IfStatement",
										"src": "1410:84:0"
									},
									{
										"attributes": {
											"assignments": [
												103
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "id",
													"scope": 155,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 102,
														"name": "ElementaryTypeName",
														"src": "1504:4:0"
													}
												],
												"id": 103,
												"name": "VariableDeclaration",
												"src": "1504:7:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 11,
															"type": "mapping(address => uint256)",
															"value": "memberId"
														},
														"id": 104,
														"name": "Identifier",
														"src": "1514:8:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 77,
															"type": "address",
															"value": "targetMember"
														},
														"id": 105,
														"name": "Identifier",
														"src": "1523:12:0"
													}
												],
												"id": 106,
												"name": "IndexAccess",
												"src": "1514:22:0"
											}
										],
										"id": 107,
										"name": "VariableDeclarationStatement",
										"src": "1504:32:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 11,
																	"type": "mapping(address => uint256)",
																	"value": "memberId"
																},
																"id": 108,
																"name": "Identifier",
																"src": "1547:8:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 77,
																	"type": "address",
																	"value": "targetMember"
																},
																"id": 109,
																"name": "Identifier",
																"src": "1556:12:0"
															}
														],
														"id": 110,
														"name": "IndexAccess",
														"src": "1547:22:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "length",
															"referencedDeclaration": null,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 16,
																	"type": "struct Citizens.Member storage ref[] storage ref",
																	"value": "members"
																},
																"id": 111,
																"name": "Identifier",
																"src": "1572:7:0"
															}
														],
														"id": 112,
														"name": "MemberAccess",
														"src": "1572:14:0"
													}
												],
												"id": 113,
												"name": "Assignment",
												"src": "1547:39:0"
											}
										],
										"id": 114,
										"name": "ExpressionStatement",
										"src": "1547:39:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 103,
															"type": "uint256",
															"value": "id"
														},
														"id": 115,
														"name": "Identifier",
														"src": "1597:2:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "++",
															"prefix": false,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"member_name": "length",
																	"referencedDeclaration": null,
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 16,
																			"type": "struct Citizens.Member storage ref[] storage ref",
																			"value": "members"
																		},
																		"id": 116,
																		"name": "Identifier",
																		"src": "1602:7:0"
																	}
																],
																"id": 117,
																"name": "MemberAccess",
																"src": "1602:14:0"
															}
														],
														"id": 118,
														"name": "UnaryOperation",
														"src": "1602:16:0"
													}
												],
												"id": 119,
												"name": "Assignment",
												"src": "1597:21:0"
											}
										],
										"id": 120,
										"name": "ExpressionStatement",
										"src": "1597:21:0"
									},
									{
										"attributes": {
											"assignments": [
												122
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "m",
													"scope": 155,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Citizens.Member storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Member",
															"referencedDeclaration": 31,
															"type": "struct Citizens.Member storage pointer"
														},
														"id": 121,
														"name": "UserDefinedTypeName",
														"src": "1629:6:0"
													}
												],
												"id": 122,
												"name": "VariableDeclaration",
												"src": "1629:16:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Citizens.Member storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 16,
															"type": "struct Citizens.Member storage ref[] storage ref",
															"value": "members"
														},
														"id": 123,
														"name": "Identifier",
														"src": "1648:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 103,
															"type": "uint256",
															"value": "id"
														},
														"id": 124,
														"name": "Identifier",
														"src": "1656:2:0"
													}
												],
												"id": 125,
												"name": "IndexAccess",
												"src": "1648:11:0"
											}
										],
										"id": 126,
										"name": "VariableDeclarationStatement",
										"src": "1629:30:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "member",
															"referencedDeclaration": 26,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 122,
																	"type": "struct Citizens.Member storage pointer",
																	"value": "m"
																},
																"id": 127,
																"name": "Identifier",
																"src": "1670:1:0"
															}
														],
														"id": 129,
														"name": "MemberAccess",
														"src": "1670:8:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 77,
															"type": "address",
															"value": "targetMember"
														},
														"id": 130,
														"name": "Identifier",
														"src": "1681:12:0"
													}
												],
												"id": 131,
												"name": "Assignment",
												"src": "1670:23:0"
											}
										],
										"id": 132,
										"name": "ExpressionStatement",
										"src": "1670:23:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "memberSince",
															"referencedDeclaration": 30,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 122,
																	"type": "struct Citizens.Member storage pointer",
																	"value": "m"
																},
																"id": 133,
																"name": "Identifier",
																"src": "1704:1:0"
															}
														],
														"id": 135,
														"name": "MemberAccess",
														"src": "1704:13:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 294,
															"type": "uint256",
															"value": "now"
														},
														"id": 136,
														"name": "Identifier",
														"src": "1720:3:0"
													}
												],
												"id": 137,
												"name": "Assignment",
												"src": "1704:19:0"
											}
										],
										"id": 138,
										"name": "ExpressionStatement",
										"src": "1704:19:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "string storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "name",
															"referencedDeclaration": 28,
															"type": "string storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 122,
																	"type": "struct Citizens.Member storage pointer",
																	"value": "m"
																},
																"id": 139,
																"name": "Identifier",
																"src": "1734:1:0"
															}
														],
														"id": 141,
														"name": "MemberAccess",
														"src": "1734:6:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 79,
															"type": "string memory",
															"value": "memberName"
														},
														"id": 142,
														"name": "Identifier",
														"src": "1743:10:0"
													}
												],
												"id": 143,
												"name": "Assignment",
												"src": "1734:19:0"
											}
										],
										"id": 144,
										"name": "ExpressionStatement",
										"src": "1734:19:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 24,
															"type": "function (address,bool)",
															"value": "MembershipChanged"
														},
														"id": 145,
														"name": "Identifier",
														"src": "1764:17:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 77,
															"type": "address",
															"value": "targetMember"
														},
														"id": 146,
														"name": "Identifier",
														"src": "1782:12:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "74727565",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "true"
														},
														"id": 147,
														"name": "Literal",
														"src": "1796:4:0"
													}
												],
												"id": 148,
												"name": "FunctionCall",
												"src": "1764:37:0"
											}
										],
										"id": 149,
										"name": "ExpressionStatement",
										"src": "1764:37:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 13,
															"type": "uint256",
															"value": "numCitizens"
														},
														"id": 150,
														"name": "Identifier",
														"src": "1812:11:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "31",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 1",
															"value": "1"
														},
														"id": 151,
														"name": "Literal",
														"src": "1827:1:0"
													}
												],
												"id": 152,
												"name": "Assignment",
												"src": "1812:16:0"
											}
										],
										"id": 153,
										"name": "ExpressionStatement",
										"src": "1812:16:0"
									}
								],
								"id": 154,
								"name": "Block",
								"src": "1352:484:0"
							}
						],
						"id": 155,
						"name": "FunctionDefinition",
						"src": "1285:551:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "editMember",
							"payable": false,
							"scope": 235,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "targetMember",
											"scope": 199,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 156,
												"name": "ElementaryTypeName",
												"src": "1864:7:0"
											}
										],
										"id": 157,
										"name": "VariableDeclaration",
										"src": "1864:20:0"
									},
									{
										"attributes": {
											"constant": false,
											"name": "newName",
											"scope": 199,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 158,
												"name": "ElementaryTypeName",
												"src": "1886:6:0"
											}
										],
										"id": 159,
										"name": "VariableDeclaration",
										"src": "1886:14:0"
									}
								],
								"id": 160,
								"name": "ParameterList",
								"src": "1863:38:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 161,
								"name": "ParameterList",
								"src": "1909:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 295,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 162,
														"name": "Identifier",
														"src": "1920:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 11,
																					"type": "mapping(address => uint256)",
																					"value": "memberId"
																				},
																				"id": 163,
																				"name": "Identifier",
																				"src": "1928:8:0"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 157,
																					"type": "address",
																					"value": "targetMember"
																				},
																				"id": 164,
																				"name": "Identifier",
																				"src": "1937:12:0"
																			}
																		],
																		"id": 165,
																		"name": "IndexAccess",
																		"src": "1928:22:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 166,
																		"name": "Literal",
																		"src": "1954:1:0"
																	}
																],
																"id": 167,
																"name": "BinaryOperation",
																"src": "1928:27:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "==",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 292,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 168,
																				"name": "Identifier",
																				"src": "1972:3:0"
																			}
																		],
																		"id": 169,
																		"name": "MemberAccess",
																		"src": "1972:10:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 157,
																			"type": "address",
																			"value": "targetMember"
																		},
																		"id": 170,
																		"name": "Identifier",
																		"src": "1986:12:0"
																	}
																],
																"id": 171,
																"name": "BinaryOperation",
																"src": "1972:26:0"
															}
														],
														"id": 172,
														"name": "BinaryOperation",
														"src": "1928:70:0"
													}
												],
												"id": 173,
												"name": "FunctionCall",
												"src": "1920:79:0"
											}
										],
										"id": 174,
										"name": "ExpressionStatement",
										"src": "1920:79:0"
									},
									{
										"attributes": {
											"assignments": [
												176
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "id",
													"scope": 199,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 175,
														"name": "ElementaryTypeName",
														"src": "2010:4:0"
													}
												],
												"id": 176,
												"name": "VariableDeclaration",
												"src": "2010:7:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 11,
															"type": "mapping(address => uint256)",
															"value": "memberId"
														},
														"id": 177,
														"name": "Identifier",
														"src": "2020:8:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 157,
															"type": "address",
															"value": "targetMember"
														},
														"id": 178,
														"name": "Identifier",
														"src": "2029:12:0"
													}
												],
												"id": 179,
												"name": "IndexAccess",
												"src": "2020:22:0"
											}
										],
										"id": 180,
										"name": "VariableDeclarationStatement",
										"src": "2010:32:0"
									},
									{
										"attributes": {
											"assignments": [
												182
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "m",
													"scope": 199,
													"stateVariable": false,
													"storageLocation": "storage",
													"type": "struct Citizens.Member storage pointer",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"contractScope": null,
															"name": "Member",
															"referencedDeclaration": 31,
															"type": "struct Citizens.Member storage pointer"
														},
														"id": 181,
														"name": "UserDefinedTypeName",
														"src": "2053:6:0"
													}
												],
												"id": 182,
												"name": "VariableDeclaration",
												"src": "2053:16:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "struct Citizens.Member storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 16,
															"type": "struct Citizens.Member storage ref[] storage ref",
															"value": "members"
														},
														"id": 183,
														"name": "Identifier",
														"src": "2072:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 176,
															"type": "uint256",
															"value": "id"
														},
														"id": 184,
														"name": "Identifier",
														"src": "2080:2:0"
													}
												],
												"id": 185,
												"name": "IndexAccess",
												"src": "2072:11:0"
											}
										],
										"id": 186,
										"name": "VariableDeclarationStatement",
										"src": "2053:30:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "string storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "name",
															"referencedDeclaration": 28,
															"type": "string storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 182,
																	"type": "struct Citizens.Member storage pointer",
																	"value": "m"
																},
																"id": 187,
																"name": "Identifier",
																"src": "2094:1:0"
															}
														],
														"id": 189,
														"name": "MemberAccess",
														"src": "2094:6:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 159,
															"type": "string memory",
															"value": "newName"
														},
														"id": 190,
														"name": "Identifier",
														"src": "2103:7:0"
													}
												],
												"id": 191,
												"name": "Assignment",
												"src": "2094:16:0"
											}
										],
										"id": 192,
										"name": "ExpressionStatement",
										"src": "2094:16:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 24,
															"type": "function (address,bool)",
															"value": "MembershipChanged"
														},
														"id": 193,
														"name": "Identifier",
														"src": "2121:17:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 157,
															"type": "address",
															"value": "targetMember"
														},
														"id": 194,
														"name": "Identifier",
														"src": "2139:12:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "74727565",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "true"
														},
														"id": 195,
														"name": "Literal",
														"src": "2153:4:0"
													}
												],
												"id": 196,
												"name": "FunctionCall",
												"src": "2121:37:0"
											}
										],
										"id": 197,
										"name": "ExpressionStatement",
										"src": "2121:37:0"
									}
								],
								"id": 198,
								"name": "Block",
								"src": "1909:257:0"
							}
						],
						"id": 199,
						"name": "FunctionDefinition",
						"src": "1844:322:0"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "removeMember",
							"payable": false,
							"scope": 235,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "targetMember",
											"scope": 234,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 200,
												"name": "ElementaryTypeName",
												"src": "2363:7:0"
											}
										],
										"id": 201,
										"name": "VariableDeclaration",
										"src": "2363:20:0"
									}
								],
								"id": 202,
								"name": "ParameterList",
								"src": "2362:22:0"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 203,
								"name": "ParameterList",
								"src": "2392:0:0"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 295,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 204,
														"name": "Identifier",
														"src": "2403:7:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 11,
																					"type": "mapping(address => uint256)",
																					"value": "memberId"
																				},
																				"id": 205,
																				"name": "Identifier",
																				"src": "2411:8:0"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 201,
																					"type": "address",
																					"value": "targetMember"
																				},
																				"id": 206,
																				"name": "Identifier",
																				"src": "2420:12:0"
																			}
																		],
																		"id": 207,
																		"name": "IndexAccess",
																		"src": "2411:22:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 208,
																		"name": "Literal",
																		"src": "2437:1:0"
																	}
																],
																"id": 209,
																"name": "BinaryOperation",
																"src": "2411:27:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "==",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 292,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 210,
																				"name": "Identifier",
																				"src": "2455:3:0"
																			}
																		],
																		"id": 211,
																		"name": "MemberAccess",
																		"src": "2455:10:0"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 201,
																			"type": "address",
																			"value": "targetMember"
																		},
																		"id": 212,
																		"name": "Identifier",
																		"src": "2469:12:0"
																	}
																],
																"id": 213,
																"name": "BinaryOperation",
																"src": "2455:26:0"
															}
														],
														"id": 214,
														"name": "BinaryOperation",
														"src": "2411:70:0"
													}
												],
												"id": 215,
												"name": "FunctionCall",
												"src": "2403:79:0"
											}
										],
										"id": 216,
										"name": "ExpressionStatement",
										"src": "2403:79:0"
									},
									{
										"attributes": {
											"assignments": [
												218
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "id",
													"scope": 234,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 217,
														"name": "ElementaryTypeName",
														"src": "2493:4:0"
													}
												],
												"id": 218,
												"name": "VariableDeclaration",
												"src": "2493:7:0"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 11,
															"type": "mapping(address => uint256)",
															"value": "memberId"
														},
														"id": 219,
														"name": "Identifier",
														"src": "2503:8:0"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 201,
															"type": "address",
															"value": "targetMember"
														},
														"id": 220,
														"name": "Identifier",
														"src": "2512:12:0"
													}
												],
												"id": 221,
												"name": "IndexAccess",
												"src": "2503:22:0"
											}
										],
										"id": 222,
										"name": "VariableDeclarationStatement",
										"src": "2493:32:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "delete",
													"prefix": true,
													"type": "tuple()"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "struct Citizens.Member storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 16,
																	"type": "struct Citizens.Member storage ref[] storage ref",
																	"value": "members"
																},
																"id": 223,
																"name": "Identifier",
																"src": "2543:7:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 218,
																	"type": "uint256",
																	"value": "id"
																},
																"id": 224,
																"name": "Identifier",
																"src": "2551:2:0"
															}
														],
														"id": 225,
														"name": "IndexAccess",
														"src": "2543:11:0"
													}
												],
												"id": 226,
												"name": "UnaryOperation",
												"src": "2536:18:0"
											}
										],
										"id": 227,
										"name": "ExpressionStatement",
										"src": "2536:18:0"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "delete",
													"prefix": true,
													"type": "tuple()"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 11,
																	"type": "mapping(address => uint256)",
																	"value": "memberId"
																},
																"id": 228,
																"name": "Identifier",
																"src": "2572:8:0"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 201,
																	"type": "address",
																	"value": "targetMember"
																},
																"id": 229,
																"name": "Identifier",
																"src": "2581:12:0"
															}
														],
														"id": 230,
														"name": "IndexAccess",
														"src": "2572:22:0"
													}
												],
												"id": 231,
												"name": "UnaryOperation",
												"src": "2565:29:0"
											}
										],
										"id": 232,
										"name": "ExpressionStatement",
										"src": "2565:29:0"
									}
								],
								"id": 233,
								"name": "Block",
								"src": "2392:210:0"
							}
						],
						"id": 234,
						"name": "FunctionDefinition",
						"src": "2341:261:0"
					}
				],
				"id": 235,
				"name": "ContractDefinition",
				"src": "128:2479:0"
			}
		],
		"id": 236,
		"name": "SourceUnit",
		"src": "0:2607:0"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.19+commit.c4cbbb05.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0x2d5ae702723d256ea555d450a38ee6a9e80c8955"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-03-13T19:12:20.012Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Citizens.json
// module id = 132
// module chunks = 0